import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";

export const LegalLayout = ({ title, subtitle, children, testId }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = `${title} | Kilic Gebäudeservice`;
  }, [title]);

  return (
    <main className="min-h-screen bg-[#fafafa]" data-testid={testId}>
      <div className="relative overflow-hidden bg-[var(--kilic-blue)] pb-16 pt-32">
        <div className="pointer-events-none absolute -right-16 -top-10 h-64 w-64 rounded-full bg-[var(--kilic-green)]/30 blur-[100px]" />
        <div className="relative mx-auto max-w-4xl px-5 md:px-8">
          <Link
            to="/"
            data-testid="legal-back-link"
            className="inline-flex items-center gap-2 text-sm font-semibold text-white/80 transition-colors hover:text-white"
          >
            <ArrowLeft className="h-4 w-4" /> Zurück zur Startseite
          </Link>
          <h1 className="mt-6 font-display text-4xl font-extrabold tracking-tighter text-white sm:text-5xl">
            {title}
          </h1>
          {subtitle && <p className="mt-3 max-w-2xl text-white/70">{subtitle}</p>}
        </div>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="mx-auto max-w-4xl px-5 py-16 md:px-8"
      >
        <div className="prose-legal space-y-8 text-neutral-700">{children}</div>
      </motion.div>
    </main>
  );
};

export const LegalBlock = ({ heading, children }) => (
  <section>
    {heading && (
      <h2 className="font-display text-xl font-bold text-neutral-900">
        {heading}
      </h2>
    )}
    <div className="mt-3 space-y-2 text-sm leading-relaxed text-neutral-600">
      {children}
    </div>
  </section>
);
